<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/POA/components/Evaluation/Final/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>